const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\W_]{8,}$/

const phoneNumberRegex = /^\+?[1-9]\d{0,2}(?:[\s()-]?\d{2,4}){2,4}$/
// valid phone numbers examples:
// +977 984 123 4567
// +977-98-4123-4567
// +1 234 567 8901
// +44 (20) 7946 0958
// 984 123 4567
// 984-12-3456
// 1234 567 890

const certificationNumberRegex = /^[A-Za-z0-9-]{1,}$/
//valid certification number examples:
// ABCD-1234
// 1234-5678-ABCD
// CERT-2023-0001
// XYZ-9876
// 12345

const urlRegex = /^https?:\/\/(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?::\d{1,5})?(?:\/[^\s]*)?$/

export { certificationNumberRegex, passwordRegex, phoneNumberRegex, urlRegex }
